import { createSelector } from 'reselect';

const historySelector = props => props.history;
const matchSelector = props => props.match;
const locationSelector = props => props.location;

export const searchParameterSelector = createSelector(
  historySelector,
  history => history.location.search
);

export const matchParameterSelector = createSelector(
  matchSelector,
  match => match.params
);

export const fullPathSelector = createSelector(
  locationSelector,
  location => `${location.pathname}${location.search}`
);



// WEBPACK FOOTER //
// ./src/selectors/RouterSelector.js